// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-xxxlarge-superElipse-81d0ed8f","strokeWidth":"super-ellipse-skins-xxxlarge-strokeWidth-07adf131"};